// test2059
(2059 && 0);
